module.exports = __webpack_public_path__ + "static/media/gallery-img-7.f5f73826.jpg";